import React, { useState, useRef } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, FormGroup, Box, Grid,Card } from '@mui/material';
import { Link } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { toast } from 'react-toastify';
import axios from 'axios';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Typography from '@mui/material/Typography';

const EditUserForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    image: null,
    publish: false,  // Checkbox state added here
  });

  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value, // Update the checkbox correctly
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
  
    // Prepare the data to be sent
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        formDataToSend.append(`itemDetails[${key}]`, formData[key]);
      }
    });
  
    // Add image if present
    if (formData.image) {
      formDataToSend.append('mediaFiles[]', formData.image);
    }
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/items/create`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.status === 201) {
        toast.success(response.data.message);
        setFormData({
          name: '',
          email: '',
          phone: '',
          image: null,
          publish: false,  // Reset checkbox state
        });
  
        // Log the formData after submission
        console.log('Form submitted successfully:', formData);
      }
    } catch (error) {
      toast.error('User not updated');
      console.error('Error creating item:', error);
  
      // Log the error and formData in case of failure
      console.log('Form submission failed:', formData);
    }
  };
  return (
    <>
    <Box sx={{ maxWidth: '70%', margin: 'auto', padding: 2 }}>
      <form onSubmit={handleSubmit}>
        <fieldset style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <legend style={{ padding: '8px', width: 'auto', background: '#3C7F10', color: '#fff', borderRadius: '8px' }}>
            Edit User
          </legend>

          <Grid className='input-field-cls' container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                Name
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                helperText="Insert name"
              />
            </Grid>

            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                Phone*
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                required
                helperText="Enter your phone number"
              />
            </Grid>

            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                Email
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                helperText="Enter your email address"
              />
            </Grid>

            <Grid item xs={2} sm={12}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                Image*
              </Typography>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                ref={fileInputRef}
                style={{ marginBottom: '10px' }}
              />
              <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                Insert image in jpg/png format
              </Typography>
            </Grid>
          </Grid>
        </fieldset>

        <fieldset style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <legend style={{ padding: '8px', width: 'auto', background: '#3C7F10', color: '#fff', borderRadius: '8px' }}>
            User (Activate/Deactivate)
          </legend>
          <FormGroup sx={{ marginBottom: 1, fontWeight: '500' }}>
            <FormControlLabel
              control={<Checkbox checked={formData.publish} onChange={handleChange} name="publish" />}
              label="Active"
            />
          </FormGroup>
        </fieldset>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button variant="contained" sx={{ bgcolor: 'green', color: '#fff' }} type="submit">
            <SaveIcon sx={{ pr: 1 }} />
            Save
          </Button>
          <Link to="/users-customer" style={{ textDecoration: 'none' }}>
            <Button variant="contained" sx={{ bgcolor: 'transparent', color: 'green', boxShadow: 'unset' }}>
              <SettingsBackupRestoreIcon sx={{ pr: 1 }} />
              Back
            </Button>
          </Link>
        </Box>
      </form>
    </Box>
  </>
  );
};

export default EditUserForm;
